// Components
import { BaseTable } from "components"

// Form
import { useFormContext, useWatch } from "react-hook-form"

// Types
import type { FormType } from "pages/Finance/Transaction/utils"

// Utils
import { convertNumber } from "utils"
import { getAmountDiff } from "pages/Finance/Transaction/utils"
import { getAcc as getAccSpendMoney } from "pages/Finance/Transaction/SpendMoney/utils"

export function AccTable() {
  // Form
  const { control } = useFormContext<FormType>()
  const amount = useWatch({
    control,
    name: "amount"
  })
  const datajournal = useWatch({
    control,
    name: "datajournal"
  })
  const tax_inclusive = useWatch({
    control,
    name: "tax_inclusive"
  })

  // Hooks
  const { sub_total, tax } = getAccSpendMoney(datajournal, tax_inclusive)

  // Vars
  const amount_diff = getAmountDiff(amount, sub_total, tax)
  const diff = amount_diff - (!tax_inclusive ? tax : 0)

  return (
    <BaseTable className="w-full min-w-[100px] md:max-w-[400px]">
      <tbody className="text-lg">
        <tr className="border-dotted border-b-2">
          <td className="w-[1px] whitespace-nowrap pr-3 pt-5 uppercase font-bold">Sub Total</td>
          <td className="pt-5">: {convertNumber(sub_total).intoCurrency}</td>
        </tr>
        <tr className="border-dotted border-b-2">
          <td className="w-[1px] whitespace-nowrap pr-3 pt-5 uppercase font-bold">Tax</td>
          <td className="pt-5">: {convertNumber(tax).intoCurrency}</td>
        </tr>
        <tr className="border-dotted border-b-2">
          <td className="w-[1px] whitespace-nowrap pr-3 pt-5 uppercase font-bold">Allocated</td>
          <td className="pt-5">: {convertNumber(amount + (!tax_inclusive ? tax : 0)).intoCurrency}</td>
        </tr>
        <tr className="border-dotted border-b-2">
          <td className="w-[1px] whitespace-nowrap pr-3 pt-5 uppercase font-bold">Balance</td>
          <td className="pt-5">: <span className={`${diff > 0 && "text-error"}`}>{convertNumber(diff).intoCurrency}</span></td>
        </tr>
      </tbody>
    </BaseTable>
  )
}